<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import { Form } from "element-ui";
    import Loader from '~/components/loader/components/loader';
    import PasswordStrength from '~/components/password_strength/components/password_strength';
    import TogglePasswordInput from '~/components/toggle_password_input/components/toggle_password_input';
    import Vue from 'vue';
    import VueButton from '~/components/button/components/button';

    Vue.use(Form);

    export default {
        name: 'reset-password-form',

        components: {
            Loader,
            PasswordStrength,
            TogglePasswordInput,
            VueButton
        },

        props: {
            token: {
                type: String,
                required: true
            }
        },

        mounted() {
            this.getPasswordRules(this.token);
            this.setRedemptionToken(this.token);
        },

        data() {
            return {
                rules: {
                    confirmPassword: [
                        {
                            message: 'Passwords do not match',
                            trigger: 'blur',
                            validator: (rule, value, callback) => {
                                value !== this.passwordForm.newPassword ? callback(new Error(rule.message)) : callback();
                            }
                        }
                    ],
                }
            }
        },

        computed: {
            ...mapState('passwordSettings', [
                'loading',
                'passwordForm',
                'passwordRules',
                'passwordResetRules',
                'passwordIsValid',
                'redemptionToken',
                'valid'
            ]),

            isDisabled() {
                return !this.passwordIsValid
                       || this.loading.formPost;
            }
        },

        methods: {
            ...mapActions('passwordSettings', [
                'getPasswordRules',
                'postSetPassword'
            ]),

            ...mapMutations('passwordSettings', [
                'setRedemptionToken',
                'updatePasswordIsValid',
                'updateValid'
            ]),

            saveSettings() {
                this.validateForm();
                if (this.valid) {
                    this.postSetPassword();
                }
            },

            validateForm() {
                if (this.$refs.passwordForm) {
                    this.$refs.passwordForm.validate((valid) => {
                        this.updateValid(valid);
                    });
                }
            }
        }
    }
</script>

<template>
    <div>
        <loader :is-loading="loading.passwordRules"></loader>

        <div>
            <el-form
                :model="passwordForm"
                ref="passwordForm"
                :rules="rules"
                @submit.native.prevent>
                <toggle-password-input
                    prop-name="newPassword"
                    label-name="New Password"
                    v-model="passwordForm.newPassword">
                </toggle-password-input>

                <password-strength
                    optional-class="password-compliance"
                    :rules="passwordRules"
                    :value="passwordForm.newPassword"
                    @password-changed="updatePasswordIsValid">
                </password-strength>

                <toggle-password-input
                    prop-name="confirmPassword"
                    label-name="Confirm Password"
                    v-model="passwordForm.confirmPassword">
                </toggle-password-input>
            </el-form>
        </div>

        <div class="login-buttons">
            <vue-button
                class="btn btn-block btn-primary btn-lg login-option-label"
                type="primary"
                :disabled="isDisabled"
                @click="saveSettings">
                Save password
            </vue-button>
        </div>
    </div>
</template>
